import { render, staticRenderFns } from "./SuiviAdmin.vue?vue&type=template&id=0750bea0&"
import script from "./SuiviAdmin.vue?vue&type=script&lang=js&"
export * from "./SuiviAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports